import { Section } from "./Section";
import { Reveal } from "./Reveal";

const QA = [
    {
        q: "What is PPF?",
        a: "Paint Protection Film — a clear, self-healing urethane layer installed over paint to take stone chips and scratches instead of your clear coat.",
    },
    {
        q: "Why ceramic?",
        a: "A ceramic coating bonds to paint and adds lasting gloss, hydrophobic behaviour and easier maintenance over corrected paintwork.",
    },
    {
        q: "What is paint correction?",
        a: "Machine polishing that removes swirls, haze and light defects from the clear coat — restoring depth and clarity before protection goes on.",
    },
    {
        q: "When does your car need detailing?",
        a: "When a wash no longer restores it — embedded contamination, dull paint, tired interiors and neglected trim are the signals.",
    },
];

const VS = [
    ["Primary role", "Physical impact protection", "Surface protection & gloss"],
    ["Best for", "High-impact zones, new paint", "Gloss, water behaviour, easy cleaning"],
    ["What it won't do", "Add coating-level slickness on its own", "Stop stone chips or deep scratches"],
    ["Together?", "PPF on impact zones — ceramic over the rest", ""],
];

export const Education = () => (
    <Section id="education" index="07" label="Education" title="Understand the work.">
        <div className="mt-14 grid gap-px border border-rz-steel/60 bg-rz-steel/60 sm:grid-cols-2">
            {QA.map((item, i) => (
                <Reveal key={item.q} delay={i * 0.05} className="bg-rz-black p-8">
                    <h3 className="font-display text-lg font-bold uppercase tracking-wide text-rz-white">
                        {item.q}
                    </h3>
                    <p className="mt-3 max-w-[50ch] text-sm leading-relaxed text-rz-smoke">{item.a}</p>
                </Reveal>
            ))}
        </div>
        <Reveal className="mt-8" delay={0.08}>
            <div className="rz-corners border border-rz-steel/60 bg-rz-graphite/40">
                <div className="grid grid-cols-3 border-b border-rz-steel/60 px-6 py-4">
                    <span className="font-display text-[10px] uppercase tracking-[0.22em] text-rz-smoke" />
                    <span className="text-center font-display text-sm font-bold uppercase tracking-[0.18em] text-rz-white">
                        PPF
                    </span>
                    <span className="text-center font-display text-sm font-bold uppercase tracking-[0.18em] text-rz-white">
                        Ceramic
                    </span>
                </div>
                {VS.map(([label, ppf, ceramic], i) => (
                    <div
                        key={label}
                        className={`grid grid-cols-3 items-center gap-3 px-6 py-4 ${
                            i < VS.length - 1 ? "border-b border-rz-steel/40" : ""
                        }`}
                    >
                        <span className="font-display text-[10px] uppercase tracking-[0.2em] text-rz-smoke">
                            {label}
                        </span>
                        <span className={`text-center text-[13px] leading-snug ${i === VS.length - 1 ? "col-span-2 text-rz-red" : "text-rz-white/85"}`}>
                            {i === VS.length - 1 ? ppf : ppf}
                        </span>
                        {i < VS.length - 1 && (
                            <span className="text-center text-[13px] leading-snug text-rz-white/85">
                                {ceramic}
                            </span>
                        )}
                    </div>
                ))}
            </div>
            <p className="mt-4 text-[12px] uppercase tracking-[0.18em] text-rz-smoke">
                Not sure which your car needs? The free inspection answers that.
            </p>
        </Reveal>
    </Section>
);
